import React from "react";
import "../../../Styles/Content.css";

const SocialMediaContent=()=>{
    return(
        <div className="social-media-content">

        </div>
    )
} 
export default SocialMediaContent;